import React from 'react';

import { clsx } from 'clsx';

import FadeIn from 'src/components/elements/FadeIn';

import JourneyStages from './JourneyStages';
import VideoBlock from './VideoBlock';

import styles from './StartTheJourney.scss';

const StartTheJourney = () => {
  return (
    <section data-locator="partnersStartTheJourney" className={styles.journeyContainer}>
      <div className={styles.titleWrapper}>
        <FadeIn delay={0.2}>
          <h2 className={styles.title}>
            <span className={clsx(styles.title, styles.titleThin)}>Let's start</span>{' '}
            the&nbsp;journey!
          </h2>
        </FadeIn>
        <FadeIn delay={0.4}>
          <p className={clsx(styles.subTitle, styles.journeySubTitle)}>
            We've got you covered with a tailored
            <br />
            travel platform
          </p>
        </FadeIn>
      </div>
      <FadeIn delay={0.6}>
        <VideoBlock />
      </FadeIn>
      <JourneyStages />
    </section>
  );
};

export default StartTheJourney;
